const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect width="28" height="28" rx="9" fill="currentColor" />
    <path
      d="M7.5 13.6 14 8.2l6.5 5.4V20a.8.8 0 0 1-.8.8h-3.4v-4.3h-4.6v4.3H8.3a.8.8 0 0 1-.8-.8v-6.4Z"
      fill="#fff"
    />
    <path
      d="M6 14.4 14 7.6l8 6.8"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity=".5"
    />
  </svg>
)

export { Logo }
